import React, { useState } from 'react';
import BugReportModal from './BugReportModal';
import TermsModal from './TermsModal';
import PrivacyModal from './PrivacyModal';

function Footer() {
  const [showBugModal, setShowBugModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  return (
    <footer className="app-footer">
      <div>
        <p>&copy; {new Date().getFullYear()} Weekly Pickem. All rights reserved.</p>
      </div>
      <div className="footer-links">
        <div className="footer-links-group">
          <h2 className='footer-link-header'>Site Links</h2>
          <a href="/" onClick={e => {
            if (window.location.pathname === "/") {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }
          }}>Home</a>
          <a href="/login">Login</a>
          <a href="/register">Register</a>
          <a href="/profile">Profile</a>
        </div>
        <div className="footer-links-group">
          <h2 className='footer-link-header'>Weekly Pickem</h2>
          <a href="/about">About</a>
          <a href="#" onClick={e => {e.preventDefault(); setShowPrivacyModal(true);}}>Privacy Policy</a>
          <a href="#" onClick={e => {e.preventDefault(); setShowTermsModal(true);}}>Terms of Service</a>
        </div>
        <div className="footer-links-group">
          <h2 className='footer-link-header'>Contact Us</h2>
          {/*  <a href="https://instagram.com/your-instagram" target="_blank" rel="noopener noreferrer">
            Instagram
          </a>
          <a href="https://twitter.com/your-twitter" target="_blank" rel="noopener noreferrer">
            Twitter
          </a> */}
          <p style={{marginLeft:"-10px"}}>weeklypickem25@gmail.com</p>
          <a href="#" onClick={e => {e.preventDefault(); setShowBugModal(true);}}>Report a Bug</a>
        </div>
      </div>
  <BugReportModal isOpen={showBugModal} onClose={() => setShowBugModal(false)} />
  <TermsModal isOpen={showTermsModal} onClose={() => setShowTermsModal(false)} />
  <PrivacyModal isOpen={showPrivacyModal} onClose={() => setShowPrivacyModal(false)} />
    </footer>
  );
}
export default Footer;